import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
  useLocation,
} from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { useEffect } from "react";
import "./App.css";
import { routes } from "./routes";
import PageLayout from "./global/components/Layout/PageLayout";
import RequestDemo from "./modules/RequestDemo/Page/RequestDemo";
import { LoginProvider } from "./lib/loginContext";
import ProtectedRoute from "./lib/ProtectedRoute";
import LegacyRedirectHandler from "./lib/LegacyRedirectHandler";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <HelmetProvider>
      <LoginProvider>
        <Router>
          {/* Scroll to top on every page navigation */}
          <ScrollToTop />

          {/* Legacy URL Redirect Handler - handles old sicunet.com URLs on client-side */}
          <LegacyRedirectHandler />

          <Routes>
            {routes.map((route, id) => (
              <Route
                key={id}
                path={route.path}
                element={
                  route.protected ? (
                    // Wrap protected routes with ProtectedRoute
                    <ProtectedRoute>
                      <PageLayout children={route.element} />
                    </ProtectedRoute>
                  ) : (
                    // Regular routes
                    <PageLayout children={route.element} />
                  )
                }
              />
            ))}

            {/* Wrap RequestDemo with PageLayout */}
            <Route
              path="/requestdemo"
              element={<PageLayout children={<RequestDemo />} />}
            />

            {/* Catch-all route for 404 - redirect to home */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Router>
      </LoginProvider>
    </HelmetProvider>
  );
}

export default App;
